import { MultiValue } from 'react-select';
import { Option, SelectOption, SelectProps } from './types';

export const isArray = <T>(value: T | T[]): value is T[] => !!(value as T[])?.map;

export const isMultiValue = <T>(value: SelectProps<T>['value']): value is MultiValue<SelectOption<T>> =>
    !!(value as MultiValue<SelectOption<T>>)?.map;

export const getOptionByValue = <T>(value: T, options: SelectOption<T>[]): SelectOption<T> | undefined => {
    return options.find((option) => option.value === value);
};

export const getSelectMultiValueFromOptions = <T>(
    values: T[],
    options: SelectOption<T>[]
): MultiValue<SelectOption<T>> => {
    return options.filter((option) => values.includes(option.value));
};

export const getSelectOptions = <T>(options: Option<T>[]): SelectOption<T>[] =>
    options.map((option) => ({
        value: option.value,
        label: option.label,
        isDisabled: option.disabled
    }));
